export const ORDER_MODE_STORAGE_KEY = 'orderMode';
export const ORDER_MODE_CHANGE_EVENT = 'orderModeChange';

export const ORDER_MODES = {
    DINE_IN: 'dine-in',
    DELIVERY: 'delivery'
};

export const getOrderMode = () => {
    if (typeof window === 'undefined') {
        return ORDER_MODES.DINE_IN;
    }

    const storedMode = window.localStorage.getItem(ORDER_MODE_STORAGE_KEY);
    return storedMode === ORDER_MODES.DELIVERY ? ORDER_MODES.DELIVERY : ORDER_MODES.DINE_IN;
};

export const isDeliveryMode = () => getOrderMode() === ORDER_MODES.DELIVERY;

export const setOrderMode = (mode) => {
    if (typeof window === 'undefined') {
        return ORDER_MODES.DINE_IN;
    }

    const nextMode = mode === ORDER_MODES.DELIVERY ? ORDER_MODES.DELIVERY : ORDER_MODES.DINE_IN;
    window.localStorage.setItem(ORDER_MODE_STORAGE_KEY, nextMode);
    window.dispatchEvent(new CustomEvent(ORDER_MODE_CHANGE_EVENT, { detail: nextMode }));
    return nextMode;
};
